import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import fr from "./locales/fr.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import it from "./locales/it.json";
import zhcn from "./locales/zh-cn.json";
import ja from "./locales/ja.json";

// Langues PUBLIQUES supportées (le back-office reste 100% FR, hors i18n).
export const SUPPORTED = [
  { code: "fr", label: "Français", short: "FR", html: "fr" },
  { code: "en", label: "English", short: "EN", html: "en" },
  { code: "es", label: "Español", short: "ES", html: "es" },
  { code: "it", label: "Italiano", short: "IT", html: "it" },
  { code: "zh-cn", label: "简体中文", short: "中文", html: "zh-CN" },
  { code: "ja", label: "日本語", short: "日本語", html: "ja" },
];
export const SUPPORTED_CODES = SUPPORTED.map((s) => s.code);
export const DEFAULT_LANG = "fr";

// Normalise n'importe quel code navigateur/URL vers une langue supportée.
// fr*→fr, en*→en, es*→es, it*→it, zh-CN/zh-Hans/zh*→zh-cn, ja*→ja, sinon fr.
export function normalizeLang(lng) {
  if (!lng) return DEFAULT_LANG;
  const l = String(lng).toLowerCase().replace("_", "-");
  if (l.startsWith("fr")) return "fr";
  if (l.startsWith("en")) return "en";
  if (l.startsWith("es")) return "es";
  if (l.startsWith("it")) return "it";
  if (l === "zh-cn" || l === "zh-hans" || l.startsWith("zh")) return "zh-cn";
  if (l.startsWith("ja")) return "ja";
  return DEFAULT_LANG;
}

export function htmlLangFor(code) {
  return (SUPPORTED.find((s) => s.code === normalizeLang(code)) || SUPPORTED[0]).html;
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      es: { translation: es },
      it: { translation: it },
      "zh-cn": { translation: zhcn },
      ja: { translation: ja },
    },
    fallbackLng: DEFAULT_LANG,
    supportedLngs: SUPPORTED_CODES,
    // Phase H bugfix (2026-09-21) — par défaut i18next met la région en
    // MAJUSCULE (ex. "zh-cn" → "zh-CN"), ce qui ne matche PAS nos clés
    // resources en minuscules → fallback silencieux vers FR. `lowerCaseLng`
    // force la casse basse dans TOUT le pipeline (resourceStore, fallback,
    // languageChanged), rendant le changement de langue réellement effectif.
    lowerCaseLng: true,
    load: "currentOnly",
    // Détection : PRIORITÉ 1 choix explicite (querystring ?lng= puis localStorage),
    // PRIORITÉ 2 navigateur (Accept-Language). Langue non supportée → FR (fallback).
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lng",
      lookupLocalStorage: "itercatus_lang",
      caches: ["localStorage"],
      convertDetectedLanguage: (l) => normalizeLang(l),
    },
    interpolation: { escapeValue: false },
    returnEmptyString: false,
    react: { useSuspense: false },
  });

// SEO : garde <html lang> synchronisé avec la langue publique courante.
function applyHtmlLang(code) {
  try {
    document.documentElement.lang = htmlLangFor(code);
  } catch (_) {}
}
applyHtmlLang(i18n.language);
i18n.on("languageChanged", applyHtmlLang);

export default i18n;
